module.exports = __webpack_public_path__ + "static/media/tokyo.8778901a.jpg";